import React from "react";

function getInitials(name) {
  if (!name || name === "Unknown") return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function formatTime(dateStr) {
  try {
    const d = new Date(dateStr);
    const now = new Date();
    const diffMs = now - d;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMin < 1) return "עכשיו";
    if (diffMin < 60) return `לפני ${diffMin} דקות`;
    if (diffHours < 24) return `לפני ${diffHours} שעות`;
    if (diffDays < 7) return `לפני ${diffDays} ימים`;

    return d.toLocaleDateString("he-IL", {
      day: "numeric",
      month: "short",
      year: d.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

const hueForName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
};

function MessageCard({ message }) {
  const { sender_name, text, photo_base64, created_at } = message;
  const initials = getInitials(sender_name);
  const hue = hueForName(sender_name || "Unknown");

  return (
    <article className="message-card">
      <div className="message-header">
        <div className="sender-info">
          <div
            className="avatar"
            style={{
              background: `linear-gradient(135deg, hsl(${hue}, 70%, 55%), hsl(${hue + 40}, 70%, 45%))`,
            }}
          >
            {initials}
          </div>
          <span className="sender-name">{sender_name || "Unknown"}</span>
        </div>
        <time className="message-time">{formatTime(created_at)}</time>
      </div>

      {text && <p className="message-text">{text}</p>}

      {photo_base64 && (
        <div className="message-photo">
          <img
            src={`data:image/jpeg;base64,${photo_base64}`}
            alt="Attached"
            loading="lazy"
          />
        </div>
      )}
    </article>
  );
}

export default MessageCard;
